export default __webpack_public_path__ + "static/profile-pic-40af1e945251345f59014a6dffb4e861.jpg";